import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SearchIcon } from 'components/icons';

const Root = styled.div`
  width: 100%;
  position: relative;
  z-index: ${(p) => p.theme.zIndex.xl};
`;

const IconContainer = styled.div`
  position: absolute;
  top: 12px;
  left: 10px;
`;

const Input = styled.input`
  outline: 0;
  height: 40px;
  width: 100%;
  border: 0;
  box-shadow: ${(p) => p.shadow ? '20px 2px 20px 5px rgb(0 0 0 / 10%), 0px 0px 0px 0px rgb(0 0 0 / 10%) inset' : 'none'};
  padding-left: ${(p) => (p.hideIcon ? p.theme.spacing.xs : p.theme.spacing.lg)};
  border: ${(p) => p.theme.font.size.xs};
  padding-right: ${(p) => p.theme.spacing.lg};
  color: ${(p) => p.theme.colors.text.main};
  font-size: ${(p) => p.theme.font.size.xs};
  background-color: ${(p) => (p.backgroundColor ? p.theme.colors[p.backgroundColor] : 'transparent')};
  transition: border-color 0.1s;

  &::placeholder {
      color: ${(p) => p.theme.colors.grey[500]};
    }

  &:focus {
    &::placeholder {
      color: ${(p) => p.theme.colors.grey[300]};
    }
  }
`;

/**
 * Component for rendering search input
 */
const SearchInput = ({
  onChange,
  onFocus,
  value,
  inputRef,
  backgroundColor,
  placeholder,
  hideIcon,
  children,
  autoFocus,
  shadow
}) => {
  return (
    <Root>
      {!hideIcon && (
        <IconContainer>
          <SearchIcon/>
        </IconContainer>
      )}

      <Input
        shadow={shadow}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
        ref={inputRef}
        backgroundColor={backgroundColor}
        type="text"
        placeholder={placeholder}
        hideIcon={hideIcon}
        autoFocus={autoFocus}
      />

      {children}
    </Root>
  );
};

SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  value: PropTypes.string.isRequired,
  ref: PropTypes.object,
  backgroundColor: PropTypes.string,
  placeholder: PropTypes.string,
  hideIcon: PropTypes.bool,
  children: PropTypes.node,
  autoFocus: PropTypes.bool,
};

export default SearchInput;
